import { ActionIcon, Tooltip } from "@mantine/core";
import { forwardRef } from "react";
import {
  // LuListEnd,
  LuList,
  // LuListMinus,
  LuListOrdered,
  // LuListTree,
} from "react-icons/lu";

export default function ListItem({ editor, language }) {
  const lists = [
    {
      type: "bulletList",
      icon: <LuList />,
      label: language.TextEditor.BulletList,
      onClick: () => editor.chain().focus().toggleBulletList().run(),
    },
    {
      type: "orderedList",
      icon: <LuListOrdered />,
      label: language.TextEditor.OrderedList,
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
    },
    // {
    //   type: "listItem-1",
    //   icon: <LuListMinus className="w-4 h-4" />,
    //   label: "Splitta listobjekt",
    //   onClick: () => editor.chain().focus().splitListItem("listItem").run(),
    //   disabled: !editor.can().splitListItem("listItem"),
    // },
    // {
    //   type: "listItem-2",
    //   icon: <LuListTree className="w-4 h-4" />,
    //   label: "Sänk listobjekt",
    //   onClick: () => editor.chain().focus().sinkListItem("listItem").run(),
    //   disabled: !editor.can().sinkListItem("listItem"),
    // },
    // {
    //   type: "listItem-3",
    //   icon: <LuListEnd className="w-4 h-4" />,
    //   label: "Lyft listobjekt",
    //   onClick: () => editor.chain().focus().liftListItem("listItem").run(),
    //   disabled: !editor.can().liftListItem("listItem"),
    // },
  ];
  return (
    <>
      {lists.map((list) => {
        const TooltipComponent = forwardRef((props, ref) => (
          <div ref={ref} {...props} style={{ pointerEvents: "none" }}>
            {list.icon}
          </div>
        ));

        return (
          <div key={list.label}>
            <div>
              <Tooltip
                classNames={{ tooltip: "tooltip-body" }}
                transitionProps={{ duration: 200 }}
                openDelay={500}
                multiline
                events={{ hover: true, focus: true, touch: true }}
                label={list.label}
              >
                <ActionIcon
                  className="text-editor-button"
                  type="button"
                  size="md"
                  w="40"
                  variant={editor.isActive(list.type) ? "light" : "subtle"}
                  onClick={list.onClick}
                  disabled={list.disabled}
                  color="black"
                >
                  <TooltipComponent />
                </ActionIcon>
              </Tooltip>
            </div>
          </div>
        );
      })}
    </>
  );
}
